    import { useState, useCallback } from "react";

export default function useMinPpmByElement(emissionPointId) {
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!emissionPointId) return;
    setLoading(true);
    try {
      const res = await fetch(
        `/api/emission-points/${emissionPointId}/min-ppm`
      );
      const data = await res.json();
      setValues(data);
      setError(null);
    } catch (err) {
      console.error("Failed to load min ppm values", err);
      setError(err);
      setValues([]);
    } finally {
      setLoading(false);
    }
  }, [emissionPointId]);

  const save = useCallback(
    async (payloadValues) => {
      if (!emissionPointId) return;
      setLoading(true);

      const sanitized = (payloadValues ?? values).filter(
        (v) =>
          v.minPpm !== null &&
          v.minPpm !== undefined &&
          v.minPpm > 0
      );

      try {
        const res = await fetch(
          `/api/emission-points/${emissionPointId}/min-ppm`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(sanitized),
          }
        );

        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        setError(null);
      } catch (err) {
        console.error("Failed to save min ppm values", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [emissionPointId, values]
  );

  return { values, setValues, load, save, loading, error };
}
